import { useEffect, useState } from "react";
import { X, Sparkles } from "lucide-react";
import { api } from "@/lib/api";

const DISMISS_KEY = "lima_beta_banner_dismissed";

export default function BetaBanner() {
  const [beta, setBeta] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === "1");

  useEffect(() => {
    api.get("/config/public").then(r => setBeta(r.data.beta)).catch(() => {});
  }, []);

  if (dismissed || !beta || !beta.active) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div className="rounded-2xl p-4 mb-6 flex items-start gap-3 bg-[#E9F0EC] border border-[#2E6B57]/25" data-testid="beta-banner">
      <Sparkles size={18} className="text-[#245544] shrink-0 mt-0.5"/>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-[#222321]">Welcome to the LIMYA Beta</p>
        <p className="text-xs text-[#222321]/70 mt-0.5">
          Enjoy complimentary access to Pro Plus features during our 14-day public beta — no credit card required.
          {beta.days_remaining != null && ` ${beta.days_remaining} day${beta.days_remaining === 1 ? "" : "s"} remaining.`}
          {" "}Beta features may change as we improve LIMYA based on community feedback.
        </p>
      </div>
      <button onClick={dismiss} className="text-[#222321]/40 hover:text-[#222321] shrink-0" data-testid="beta-banner-dismiss" aria-label="Dismiss">
        <X size={16}/>
      </button>
    </div>
  );
}
